// extracted by mini-css-extract-plugin
export default {"truncatedText":"labeledValue_truncatedText__pseD9","label":"labeledValue_label__40zv6"};